import { a3Header } from './a3';
import { a4Header } from './a4';
import { a5Header } from './a5';
import { a6Header } from './a6';
import { payaccHeader } from './payacc';

export default [...a3Header, ...a4Header, ...a5Header, ...a6Header, ...payaccHeader];
